import { ProductInCart } from './cart/productInCart';
import { Season } from 'types/seasons';
import { rcEnums } from './rc.enums';

// TODO: remove this, should import from @bondsports/types https://bond-sports.atlassian.net/browse/BOND-14216
export enum ProgramTypesEnum {
	LEAGUE = 0,
	TOURNAMENT = 1,
	CLASS = 2,
	CLINIC = 3,
	CAMP = 4,
	LESSON = 5,
	CLUB = 6,
	LEAGUE_V2 = 10,
	TOURNAMENT_V2 = 11,
}

export interface Program {
	id: number;
	type: ProgramTypesEnum;
	name: string;
	sport: rcEnums.shared.SportsEnum;
	minAge: string;
	maxAge: string;
	gender: rcEnums.shared.GenderEnum;
	level: rcEnums.shared.LevelOfPlayEnum[] | null;
	description: string | null;
	mainMedia?: {
		url: string;
	};
	organizationId: number;
	longDescription?: string;
	ageCalcDate?: string;
	startDate?: string;
}

// a program/season product with all its filled steps' data:
export interface ProgramProductInCart extends ProductInCart {
	sport?: rcEnums.shared.SportsEnum;
	program: string;
	season: Season;
}
